
<script lang="ts">
  import Navbar from "./Navbar.svelte";
  import Footer from "./Footer.svelte";
  import Canvas from "./Canvas.svelte";
  import { postData } from '../helpers/utils';

  // just for capturing name while downloading;
  export let src;
  // image data in context
  export let image;
  // current stroke/bucket color
  let currentColor;

  let cfd;

  let emailTo = '';
  let senderName = '';
  // email element
  let emailInput ;

  let emailDialogFlag = false;
  let sendingEmailFlag = false;

  function showEmailDialog(){
    emailDialogFlag = true;
  }

  function closeDialog(){
    emailDialogFlag = false;
  }

  function sendEmail() {
    if(!emailInput.checkValidity()){
      return;
    }
    sendingEmailFlag = true;
    postData('https://pixobe-functions.netlify.app/.netlify/functions/colorgizer-email', {
        "to": emailTo,
        "content": cfd.save(),
        "name": senderName
      })
      .then(() => {
       // Todo
      })
      .finally(()=>{
        emailDialogFlag = false;
        sendingEmailFlag = false
      })
  }

</script>

<div class="board">
     {#if cfd}
       <Navbar {cfd} {image} {currentColor} {src} on:email={showEmailDialog}/>
     {/if}
     {#if image}
       <Canvas {image} {currentColor} bind:cfd />
     {/if}
       <Footer bind:currentColor {cfd}/>

      {#if emailDialogFlag== true}
        <div class="dialog email-dialog">
          <form>
              <button class="close-btn" on:click={closeDialog}>X</button>
              <div>
                  <label for="email">Email </label> <input type="email" id="email" bind:value={emailTo} bind:this={emailInput}/>
                  <p></p>
              </div>
              <div>
                <label for="name">Your Name:</label> <input type="text"  id="name" bind:value={senderName}/>
            </div>
            <div>
              <button on:click={sendEmail} class="send-btn" type="button"  class:hidden={sendingEmailFlag === true}
                >Send Email</button>
                <button class="sending-email-btn" type="button"  
                class:hidden={sendingEmailFlag === false}
                >Sending Email</button>
            </div>
          </form>
        </div>
      {/if}
</div>


<style type="text/scss">
  @import "Board";
</style>
